import { render, staticRenderFns } from "./SelfCheckHistoryTable.vue?vue&type=template&id=6ec31b5b&scoped=true"
import script from "./SelfCheckHistoryTable.vue?vue&type=script&lang=js"
export * from "./SelfCheckHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./SelfCheckHistoryTable.vue?vue&type=style&index=0&id=6ec31b5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec31b5b",
  null
  
)

export default component.exports